import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { CrudStore } from 'core/types/crudStore'

export const getJbpHpContactsCrud = (crudKey: string) =>
  CrudStore.get(CrudStoreItemPartner360.JBPHPContactChangeRequest, crudKey)
